import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import { selectActividadFromCurrentEmpresaByTipoActividad } from '../entity-actividades/entity-actividades.selectors';
import {
  entityDepositosAdapter,
  EntityDepositosState
} from './depositos.state';
import { selectCurrentEmpresa } from '../../empresas/entity-mis-empresas/entity-current-empresa.selectors';

const { selectEntities, selectAll } = entityDepositosAdapter.getSelectors();

export const getError = (state: EntityDepositosState): any => state.error;

export const getIsLoading = (state: EntityDepositosState): boolean =>
  state.isLoading;

export const getHasAddedSuccess = (state: EntityDepositosState): boolean =>
  state.hasAddedSuccess;

export const selectDepositosState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.depositos
);

export const selectAllDepositos = createSelector(
  selectDepositosState,
  selectAll
);
export const selectEntitiesDepositos = createSelector(
  selectDepositosState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectDepositosError = createSelector(
  selectDepositosState,
  getError
);

// MemoizedSelector<object,any>
export const selectDepositosIsLoading = createSelector(
  selectDepositosState,
  getIsLoading
);

export const selectDepositosHasAddedSuccess = createSelector(
  selectDepositosState,
  getHasAddedSuccess
);

export const selectAllDepositosFromCurrentEmpresa = createSelector(
  selectAllDepositos,
  selectCurrentEmpresa,
  (depositos, currentEmpresa) => {
    if (depositos && currentEmpresa) {
      return depositos.filter(
        (d) => d.entidad_productiva_id == currentEmpresa.id
      );
    } else {
      return [];
    }
  }
);
